<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Reset Password v1 -->
      <b-card class="mb-0">

        <!-- logo -->
        <b-link class="brand-logo">
          <hm-logo/>
        </b-link>

        <b-card-title class="mb-1">
          Reset Password 🔒
        </b-card-title>
        <b-card-text class="mb-2">
          Please type your new password
        </b-card-text>

        <!-- form -->
        <b-form
          class="auth-reset-password-form mt-2"
          @submit.prevent
        >

          <!-- password -->
          <b-form-group
            label="New Password"
            label-for="reset-password-new"
          >
            <b-input-group
              class="input-group-merge"
              :class="$v.password.$invalid?'is-invalid':''"
            >
              <b-form-input
                id="reset-password-new"
                v-model="password"
                :type="password1FieldType"
                :state="!$v.password.$invalid"
                class="form-control-merge"
                name="reset-password-new"
                placeholder="············"
              />
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  :icon="password1ToggleIcon"
                  @click="togglePassword1Visibility"
                />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <!-- confirm password -->
          <b-form-group
            label-for="reset-password-confirm"
            label="Confirm Password"
          >
            <b-input-group
              class="input-group-merge"
              :class="$v.cPassword.$invalid?'is-invalid':''"
            >
              <b-form-input
                id="reset-password-confirm"
                v-model="cPassword"
                :type="password2FieldType"
                :state="!$v.cPassword.$invalid"
                class="form-control-merge"
                name="reset-password-confirm"
                placeholder="············"
              />
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  :icon="password2ToggleIcon"
                  @click="togglePassword2Visibility"
                />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <!-- submit button -->
          <b-button
            block
            type="submit"
            variant="primary"
            @click="reset_password"
          >
            Set New Password
          </b-button>
        </b-form>

        <p class="text-center mt-2">
          <b-link :to="{name:'auth-login'}">
            <feather-icon icon="ChevronLeftIcon"/>
            Back to login
          </b-link>
        </p>

      </b-card>
      <!-- /Reset Password v1 -->
    </div>
  </div>

</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import hmLogo from '@core/layouts/components/Logo.vue'
import api from '@/libs/axios'
import { hmError, hmSuccess } from '@/libs/toastification'

export default {
  components: {
    hmLogo
  },
  data() {
    return {
      uuid: null,
      cPassword: null,
      password: null,
      // Toggle Password
      password1FieldType: 'password',
      password2FieldType: 'password'
    }
  },
  validations: {
    password: {
      required,
      minLength: minLength(6)
    },
    cPassword: {
      required,
      minLength: minLength(6),
      function(v) {
        return this.password === v
      }
    }
  },
  computed: {
    password1ToggleIcon() {
      return this.password1FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    password2ToggleIcon() {
      return this.password2FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    }
  },
  methods: {
    togglePassword1Visibility() {
      this.password1FieldType = this.password1FieldType === 'password' ? 'text' : 'password'
    },
    togglePassword2Visibility() {
      this.password2FieldType = this.password2FieldType === 'password' ? 'text' : 'password'
    },
    reset_password() {
      this.$v.$touch()
      if (this.$v.$invalid) return
      api.post('/web/user/reset_password', { uuid: this.uuid, password: this.password })
        .then(r => {
          if (r.data.code !== 'Ok') {
            return hmError(r.data.code)
          }
          hmSuccess('Password have been reset successfully')
          this.$router.push({ name: 'auth-login' })
        })
    }
  },
  mounted() {
    this.uuid = this.$route.params.uuid
    if (!this.uuid) {
      this.$router.push({ name: 'auth-login' })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
